import { render } from "./IntegrationCard.vue?vue&type=template&id=78eb2be6&scoped=true"
import script from "./IntegrationCard.vue?vue&type=script&lang=ts"
export * from "./IntegrationCard.vue?vue&type=script&lang=ts"

import "./IntegrationCard.vue?vue&type=style&index=0&id=78eb2be6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-78eb2be6"

export default script